import { PatientInfoValues } from '../enums/patient-info-values.enum';

export const PatientInfoValueOrder = {
  [PatientInfoValues.SPECIES]: 0,
  [PatientInfoValues.BREED]: 1,
  [PatientInfoValues.WEIGHT]: 0,
  [PatientInfoValues.BIRTH_DATE]: 1,
  [PatientInfoValues.GENDER]: 2,
  [PatientInfoValues.OWNER_NAME]: 0,
  [PatientInfoValues.OWNER_EMAIL]: 1,
  [PatientInfoValues.OWNER_PHONE_NUMBER]: 2
};
